import css from 'styled-jsx/css';

const styles = theme => {
  return css.resolve`
    .hotel-name-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .hotel-name {
      color: ${theme.titleColor};
      margin-bottom: 20px;
      text-align: center;
    }

    .share-root {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .share-container {
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      padding: 0 0 10px 0;
      cursor: pointer;
    }

    .share-text {
      color: ${theme.titleColor};
      margin: 0 10px 0 0;
      text-align: left;
      font-size: 14px;
    }

    .booking-completed-action {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 40px 0 0 0;
    }
  `;
};
export default styles;
